import { Card } from '@/components/sections/Card';

export const ResourcePlaceholder = () => {
  return (
    <div className="flex-1 py-16 w-full leading-5 text-sm text-primary-std">
      <Card className="py-5 px-10 flex flex-col items-center gap-5 w-2/3 mx-auto max-w-4xl text-center">
        <p className="font-semibold">Welcome to the GTM Media area!</p>
        <p className="">Here you'll find all the resources you need to get from initial setup to market ready.</p>
        <p className="">Choose a folder on the left hand side to start browsing.</p>
      </Card>
    </div>
  );
};
